import styled from 'styled-components'

import { Skeleton } from '@syconium/little-miss-figgy'

export const Body = styled.div`
  display: flex;
  width: 100%;
  padding: ${o => o.theme.spacing(5)} 0;
`
export const List = styled.ul``

export const ListItem = styled.li`
  float: left;
  padding: 10px 15px;

  &:first-child {
    padding-inline-start: 4px;
  }
`

export const Label = styled(Skeleton)`
  height: 20px;
  width: 80px;
`
